<template>
  <GridContainer
    v-if="hasOffers"
    class="visited-offer-tiles"
  >
    <h2 class="visited-offer-tiles__title">Zuletzt angesehen</h2>
    <OfferTiles
      class="visited-offer-tiles__offer-tiles"
      :offers="lastSeenOffersPaginated"
      :item-offset="itemOffset"
      :item-size="itemSize"
      always-lazy
      :spaces="spaces"
    />
  </GridContainer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import fetchOffers from '@/lib/goliath/offers';

import { GridContainer } from '@i22/td-longtail-vue-components';

import OfferTiles from '~/components/offer-tiles-container.vue';

export default {
  components: {
    GridContainer,
    OfferTiles,
  },
  props: {
    viewedArticleNumber: {
      type: String,
      default: null,
    },
    itemSize: {
      type: String,
      default: null,
    },
    spaces: {
      type: Boolean,
      default: false,
    },
    itemOffset: {
      type: String,
      default: null,
    },
    maxSize: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      isLoaded: false,
    };
  },
  mounted() {
    this.loadOffersFromLocalstorageFromGoliath();
  },
  computed: {
    ...mapGetters('last-seen-offers', {
      lastSeenArticleNumbers: 'lastSeenOffersArticleNumbers',
      lastSeenOffers: 'lastSeenFetchedOffers',
    }),
    lastSeenOffersPaginated() {
      return this.lastSeenOffers
        .filter((offer) => offer.product.articleNumber !== this.viewedArticleNumber)
        .slice(-this.maxSize);
    },
    hasOffers() {
      return (
        this.isLoaded &&
        this.lastSeenArticleNumbers.length > 0 &&
        this.hasLoadedOffers &&
        this.lastSeenOffers.length > 0
      );
    },
    hasLoadedOffers() {
      return !!this.lastSeenOffers;
    },
  },
  methods: {
    ...mapActions('last-seen-offers', ['addLastSeenOffers']),
    loadOffersFromLocalstorageFromGoliath() {
      if (this.$config.public.performanceMode.enabled) return; // skip when in minimal mode

      // offers that have been fetched and stored in the state
      const fetchedOffers = [
        this.viewedArticleNumber,
        ...this.lastSeenOffers.map((offer) => offer.product.articleNumber),
      ];

      // only fetch offers that have not already been fetched
      const offersToFetch = this.lastSeenArticleNumbers.filter(
        (articleNumber) => articleNumber !== null && !fetchedOffers.includes(articleNumber)
      );

      if (offersToFetch.length === 0) {
        this.isLoaded = true;
        return;
      }

      // Goliath Request params
      const params = {
        filter: {
          listed: true,
          articleNumbers: offersToFetch,
        },
        pagination: { size: this.maxSize },
        includeAggregations: false,
        grouped: true,
      };

      fetchOffers(params, false, true).then((data) => {
        if (data?.entries) {
          this.addLastSeenOffers(data.entries);
        }
        this.isLoaded = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.visited-offer-tiles {
  padding-block: $grid-base * 2;

  @include mq($mq-sm) {
    padding-block: $grid-base * 3;
  }
  &__title {
    text-align: center;
  }
}
</style>
